<div class="remember-password">
  <button class="close" (click)="close()">
    <i class="lf-icon lf-icon-close"></i>
  </button>
  <div class="image"></div>
  <h3 class="title">{{ 'modal.forgot_password' | translate }}</h3>
  <p class="subtitle">{{ 'modal.forgot_password_description' | translate }}</p>
</div>
